import { type Sort, SortDirection } from 'generatedTypes/flight/models';

export const DEFAULT_SORT: Sort[] = [{ direction: SortDirection.DESC, field: 'startTime' }];

export const PAGE_SIZE = 25;
